import React from 'react';
import Slider from "react-slick";
import {Card, Button, Container, Row, Col} from "react-bootstrap"
import _ from 'lodash'
import { userApi } from "../../../api"; /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
import  '../../Styles/css/w3.css'; /*Card style*/

export default props => {
    const items = props.data;
    const isReadmoreEnable=props.isReadMoreEnable?true:false;
    const industry=props.industry;
    const industry_slug=props.industry_slug?props.industry_slug:"";
    const bmo_slug=props.bmo_slug?props.bmo_slug:"";

    let showMore_url="";
    if(industry_slug!=="" || bmo_slug!==""){
        showMore_url="/search?posts=offering";
        if(bmo_slug!==""){
            showMore_url+=`&operator=${bmo_slug}`
        }else{
            showMore_url+=`&industry=${industry_slug}`;  
        }

    }else{
        showMore_url="/offerings"
    }

    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
    async function learnMoreClick(bmo,slug){
    let page="offerings";
    let bmoname = bmo[0].name;
    let obj={};
    obj['userid']=localStorage['currentuserid'];
    obj['message']= page +'-'+ bmoname +'-'+ slug ;
    await userApi.setUserActivitylog(obj); 
    window.location.href = "/"+page+"/"+slug;
    }
    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/

    const cards = items.map(item => {
        const imageURL = _.get(item,'headermedia[0].sizes.post-card-thumbnail') || ""
        const desc = item.post_excerpt.length > 155 ? item.post_excerpt.substr(0,154)+" ..." : item.post_excerpt; 
        const title = item.post_title.length > 48 ? item.post_title.substr(0,47)+" ..." : item.post_title; 

        {/*Cards Uploaded time display*/}
        const uploadeddate = item.post_date.length > 0 ? new Date(item.post_date) : new Date(item.post_modified);
        let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const uploadedFormattedDate = monthNames[uploadeddate.getMonth()] + "-" + uploadeddate.getFullYear();
        {/*Cards Uploaded time display*/}
        
        const industrymap =
            item.industry.map( ind => {
                return (
                   ind.name
                )
            })
    
        const industrylist = industrymap.length > 1 ? industrymap[0].substr(0,39) +" ..." :industrymap.length == 1 ? industrymap[0].substr(0,39) +"..." : industrymap; 


        return (
            <Card onClick={()=>learnMoreClick(item.bmos,(item.post_name!==""?item.post_name:item.ID ))} className="post-card w3-card-4 w3-padding-card zoom Cursor-pointer" key> {/*Comments: Card style-Zoom,spacing*/}
            <div>  
                <Card.Img variant="top" src={imageURL} />
            </div>
            <Card.Body className="w3-container "> 
               <div style={{height:'50px'}}>  
                    <Card.Title className="w3-textpadding-card w3-card-title-fontsize">{title}</Card.Title> {/*Card style-Zoom,spacing*/}
               </div>

               <div style={{height:'120px'}}> 
                    <Card.Text className="text-muted w3-textpadding-card">{desc}</Card.Text>  {/*Card style-Zoom,spacing*/}
                </div>
                <div style={{height:'30px'}}> 
                <Card.Text className="w3-textpadding-card">
                    {
                        item.bmos.map( bmo => {
                            return (
                                <b key={bmo.name}>{bmo.name} </b>
                            )
                        })
                    }
                    <span className="text-muted"> | </span>

                    {
                        item.industry.map( ind => {
                            return (
                            
                                <span key={ind.name}>{_.unescape(ind.name )} </span>
                                
                            )
                        })
                    }
                </Card.Text>
                </div>

                {/*Cards Uploaded time display*/}
                <Card.Text className="w3-textpadding-card">
                    <b>Uploaded On:</b> {uploadedFormattedDate} 
                </Card.Text>
                {/*Cards Uploaded time display*/}

                <Card.Text ><br/></Card.Text>
            </Card.Body>
        </Card>

            /*
            <Card className="post-card" key={item.post_title}>
                <Card.Img variant="top" src={imageURL} />
                <Card.Body>
                    <Card.Title>{item.post_title}</Card.Title>
                    <Card.Text className="text-muted">{desc}</Card.Text>
                    <Card.Text>
                        {
                            item.bmos.map( bmo => {
                                return (
                                    <b key={bmo.name}>{bmo.name} </b>
                                )
                            })
                        }
                        <span className="text-muted"> | </span>
                        {
                            item.industry.map( ind => {
                                return (
                                    <span key={ind.name}>{_.unescape(ind.name)} </span>
                                )
                            })
                        }
                    </Card.Text>                    
                   <a onClick={()=>learnMoreClick(item.bmos,(item.post_name!==""?item.post_name:item.ID ))} className={"btn btn-primary"} style={{cursor:'pointer'}}>Learn More </a>
                </Card.Body>
            </Card>
            */
        )
    })

    const sliderSettings = {
        dots: true,
        infinite: true,
        gap : 20,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4
    }
    
	return(
        <div className="my-5">
            <Container className="text-center">
                <h3 className="mb-5">{props.title?props.title:`Read more on ${industry}`}</h3>
                {
                    cards.length==0 && 
                    <div className="no-posts">
                        <h5>No Posts Available</h5>
                    </div>
                }            
                {
                    cards.length > 4 &&
                    <Slider className="post-card-slider" {...sliderSettings}>
                        {cards}
                    </Slider>
                }
                {
                    cards.length <= 4 &&
                    <Row className="post-card-slider">
                        { cards.map( (card,index) => <Col key={index} xs={6} sm={6} md={3}>{card}</Col> )}
                    </Row>
                }
                {(cards.length>0 && isReadmoreEnable) && 
                   <Row>
                       <Col md={{ span: 6, offset: 3 }} className={'flex-center'}>
                            <a className={"btn btn-outline-primary"} href={showMore_url}>Show More</a>
                       </Col>
                   </Row>
                }
            </Container>
        </div>
	)
}